import { getLocalizedMessage } from "@pimo/pimo-l10n";

type LocalizedTableColumnLabelParams = {
  dropdownFieldOneLabel?: string;
  dimensionLabel?: string;
};

export function getLocalizedTableColumnLabel(
  language: string,
  fieldName: string,
  params: LocalizedTableColumnLabelParams = {},
  categoryLabel?: string
) {
  if (fieldName === "category") {
    return (
      categoryLabel || getLocalizedMessage(language, "category") || fieldName
    );
  }

  if (fieldName === "dropdownFieldOne") {
    return (
      params.dropdownFieldOneLabel ||
      getLocalizedMessage(language, "team") ||
      fieldName
    );
  }

  if (fieldName === "dimension") {
    return (
      params.dimensionLabel ||
      getLocalizedMessage(language, "dimension") ||
      fieldName
    );
  }

  // Tables show the short "Completion" wording instead of "Degree of Completion".
  if (fieldName === "degreeOfCompletion") {
    return (
      getLocalizedMessage(language, "completion") ||
      getLocalizedMessage(language, fieldName) ||
      fieldName
    );
  }

  return getLocalizedMessage(language, fieldName) || fieldName;
}
